var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('input',{staticClass:"hidden",attrs:{"type":"file","multiple":""},on:{"change":_vm.handleSelect}}),_c('i',{staticClass:"el-icon-paperclip cursor-pointer text-white text-3xl"})])
}
var staticRenderFns = []

export { render, staticRenderFns }